import React from "react";
import style from "../../style/Pages/Help/SettingsHelp.module.css";
import { Link } from "react-router-dom";
import {
  TbArrowLeft,
  TbBuilding,
  TbBell,
  TbSettingsCog,
  TbInfoCircle,
  TbUsers,
} from "react-icons/tb";
import { GrGroup } from "react-icons/gr";
import { FiHash } from "react-icons/fi";
import { BsPersonGear } from "react-icons/bs";
import { RiFileList3Line } from "react-icons/ri";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const SettingsHelp = () => {
  return (
    <>
      <SecondaryLayout>
        <div className={style.wrapper}>
          <Link to="/help" className={style.backLink}>
            <TbArrowLeft className={style.backIcon} /> Back to Help Center
          </Link>

          <div className={style.header}>
            <TbSettingsCog className={style.headerIcon} />
            <h1>Settings</h1>
          </div>

          <div className={style.content}>
            <p>
              The <strong>Settings</strong> panel helps you control how your
              workspace looks, behaves, and how users interact. Here's what each
              section does:
            </p>

            <ul className={style.list}>
              <li>
                <TbUsers />
                <div>
                  <strong>User List</strong>
                  <br />
                  View all registered users, search by name or email, edit user
                  profiles, or deactivate/reactivate accounts as needed.
                </div>
              </li>

              <li>
                <GrGroup />
                <div>
                  <strong>Groups</strong>
                  <br />
                  Create and manage user groups for focused communication and
                  task collaboration. Assign members and control group-level
                  permissions.
                </div>
              </li>

              <li>
                <FiHash />
                <div>
                  <strong>Channel</strong>
                  <br />
                  Manage public and private channels. Add new channels, rename,
                  archive, or update participant lists to match your team
                  structure.
                </div>
              </li>

              <li>
                <BsPersonGear />
                <div>
                  <strong>User and Role</strong>
                  <br />
                  Assign roles like Admin, Staff, or Viewer to define what users
                  can access or change in the system. Modify permissions
                  anytime.
                </div>
              </li>

              <li>
                <RiFileList3Line />
                <div>
                  <strong>Logs</strong>
                  <br />
                  Track critical system events, user activities (login, updates,
                  deletions), and view action timestamps for auditing and
                  troubleshooting.
                </div>
              </li>

              <li>
                <TbBuilding />
                <div>
                  <strong>Companies</strong>
                  <br />
                  Configure your organization profile, branding, domain info,
                  and cross-company user management for multi-tenant
                  environments.
                </div>
              </li>

              <li>
                <MdOutlineDashboardCustomize />
                <div>
                  <strong>Appearance</strong>
                  <br />
                  Switch between light and dark modes, change UI theme colors,
                  font sizes, and layout preferences to personalize the
                  experience.
                </div>
              </li>

              <li>
                <TbInfoCircle />
                <div>
                  <strong>About</strong>
                  <br />
                  See app version, release history, third-party licenses,
                  developer contacts, and other meta information.
                </div>
              </li>

              <li>
                <TbBell />
                <div>
                  <strong>Notification</strong>
                  <br />
                  Manage how and when you receive alerts — turn sound on/off,
                  enable desktop popups, and control mention/mute settings.
                </div>
              </li>
            </ul>

            <p>
              Use the sidebar on the left to jump into any of these settings
              modules. Each section is designed to give you control and
              customization over your workspace experience.
            </p>
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default SettingsHelp;
